import React from 'react'

export default class DiabetesData extends React.Component {
  render () {
    var {medicalData} = this.props.data

    return (
      <div className='column-data-diabetes-report'>
        <div className='header-printable-report'>
          <div className='section-title'>Medición del estado de salud</div>
        </div>
        <div className=''>
          <div className='data-report-horizontal'>
            <div className='two-medical-data-report-container rborder'>
              <label><span className='data-title'>Balance izquierdo: </span><span className={this.props.data.balIzRange}>{(typeof medicalData.balanceNeuroMuscularIzquierdo === 'undefined') ? '' : medicalData.balanceNeuroMuscularIzquierdo + ' seg'}</span></label>
            </div>
            <div className='two-medical-data-report-container'>
              <label><span className='data-title'>Balance derecho: </span><span className={this.props.data.balDeRange}>{(typeof medicalData.balanceNeuroMuscularDerecho === 'undefined') ? '' : medicalData.balanceNeuroMuscularDerecho + ' seg'}</span></label>
            </div>
          </div>
          <div className='sep-line'></div>
        </div>
        <div className=''>
          <div className='data-report-horizontal'>
            <div className='two-medical-data-report-container rborder'>
              <label><span className='data-title'>Índice de vitalidad: </span><span className={this.props.data.indViRange}>{this.props.data.vitalityIndex.toFixed(2) + '%'}</span></label>
            </div>
            <div className='two-medical-data-report-container'>
              <label><span className='data-title'>Capacidad funcional: </span><span className={this.props.data.indCaRange}>{this.props.data.functionalIndex.toFixed(2) + '%'}</span></label>
            </div>
          </div>
          <div className='sep-line'></div>
        </div>
        <div className=''>
          <div className='data-report-horizontal'>
            <div className='two-medical-data-report-container rborder'>
              <label><span className='data-title'>Balance afectivo: </span><span className={this.props.data.balAfRange}>{this.props.data.balanceAfectivo + '%'}</span></label>
            </div>
            <div className='two-medical-data-report-container'>
              <label><span className='data-title'>Reserva funcional: </span><span className={this.props.data.resFnRange}>{this.props.data.fx_reserve.toFixed(2) + '%'}</span></label>
            </div>
          </div>
          <div className='sep-line'></div>
        </div>
        <div className=''>
          <div className='data-report-horizontal'>
            <div className='two-medical-data-report-container rborder'>
              <label><span className='data-title'>Edad vascular: </span><span className={this.props.data.edadARange}>{this.props.data.arterialAge.toFixed(1) + ' años'}</span></label>
            </div>
            <div className='two-medical-data-report-container'>
              <label><span className='data-title'>Edad biológica: </span><span className={this.props.data.edadBRange}>{this.props.data.biologicalAge.toFixed(1) + ' años'}</span></label>
            </div>
          </div>
          <div className='sep-line'></div>
        </div>
        <div className=''>
          <div className='data-report-horizontal'>
            <div className='two-medical-data-report-container'>
              <label><span className='data-title'>Caminata 5 metros: </span> <span className={this.props.data.tiempo}>{(typeof this.props.data.medicalData.tiempoCincoM === 'undefined') ? '' : this.props.data.medicalData.tiempoCincoM + ' seg'}</span></label>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

DiabetesData.propTypes = {
  data: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/PrintableDiabetes/DiabetesData.js